module.exports = __webpack_public_path__ + "static/media/DSC08670.b57a9ce3.jpg";